export const STRATEGY_ONGOING_CALL_IVR = {
    "onIVRList": function (json) {
        if (typeof onIVRList === 'function') {
            onIVRList(json.data);
        }
    },
    "onIdleStart": function (json) {
        if (typeof onIdleStart === 'function') {
            onIdleStart(json.data);
        }
    },
    "onIdleEnd": function (json) {
        if (typeof onIdleEnd === 'function') {
            onIdleEnd(json.data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyOngoingCallIvr.js